import React from "react"; 
import SignInForm from "../../components/Authentication/SignInForm";

const SignIn = () => {
  return (
    <>
      <SignInForm />
    </>
  );
};

export default SignIn;
